import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'lg' | 'xl';
  variant?: 'solid' | 'brass-edge';
  className?: string;
};
export function CtaButton({
  children,
  href = '#pricing',
  size = 'lg',
  variant = 'solid',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'xl' ? 'px-10 py-5 text-lg' : 'px-8 py-4 text-base';
  const edge = variant === 'brass-edge' ? 'ring-1 ring-brass/70 ring-offset-2 ring-offset-forest' : '';
  return <a href={href} className={`inline-flex items-center justify-center gap-2.5 rounded-xl bg-sage font-sans font-semibold text-white shadow-card transition-[background-color,transform,box-shadow] duration-200 ease-out hover:bg-sage-dark hover:shadow-lift focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 ${sizing} ${edge} ${className}`} data-id="element-89" data-mp="lkxsqhss9qpq">
      <span data-id="element-90" data-mp="15bb045xoei4t">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0" strokeWidth={1.75} aria-hidden="true" data-id="element-91" data-mp="35x5w9drqko1y" />
    </a>;
}